import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const manageHostStyleId = 'wb-v2-surface-manage-host-theme';

export const manageHostBridgeStyles = {
  'wb-surface-manage-host': {
    '--local-manage-save-gap': tokens.spacing.sm,
    '--local-manage-save-font-size': tokens.font.size.textXs,
    '--local-manage-save-line-height': tokens.lineHeight.textXs,
    '--local-manage-save-font-weight': tokens.font.weight.medium,
    '--local-manage-save-color': tokens.color.text.tertiary,
    '--local-manage-save-color-dirty': tokens.color.text.warningPrimary,
    '--local-manage-save-color-error': tokens.color.text.errorPrimary,
    '--local-manage-save-color-saved': tokens.color.text.successPrimary,
    '--local-manage-save-motion-ms': '140ms',
    '--local-manage-header-column-gap': tokens.spacing.xl,
    '--local-manage-header-row-gap': tokens.spacing.md,
    '--local-manage-chip-row-gap': tokens.spacing.xl,
    '--local-manage-chip-row-gap-compact': tokens.spacing.md,
    '--local-manage-chip-gap': tokens.spacing.sm,
    '--local-manage-chip-label-color': tokens.color.text.tertiary,
    '--local-manage-chip-label-font-size': tokens.font.size.textXs,
    '--local-manage-chip-label-line-height': tokens.lineHeight.textXs,
    '--local-manage-chip-value-max-width': '168px',
    // Entity Board still publishes this semantic canvas color through the legacy DS bridge.
    '--local-manage-form-canvas-bg': 'var(--colors-background-card-section)',
    '--local-manage-tab-rail-border': tokens.color.border.secondary,
    '--local-manage-tab-strip-padding-block': tokens.spacing.xl,
    '--local-manage-tab-strip-padding-inline': tokens.spacing.xl,
    '--local-manage-form-canvas-padding': tokens.spacing.xl,
    '--local-manage-form-section-gap': tokens.spacing.xl,
    '--local-manage-form-field-gap': tokens.spacing.xl,
    '--local-manage-form-section-shadow': tokens.shadow.xs,
    '--local-manage-container-radius': '6px',
    '--local-manage-left-rail-resize': tokens.color.border.brand,
    '--local-manage-title-font-family': tokens.font.family.display,
    '--local-manage-title-font-size': tokens.font.size.textLg,
    '--local-manage-title-font-weight': tokens.font.weight.semibold,
    '--local-manage-title-line-height': tokens.lineHeight.textLg,
    '--local-manage-title-color': tokens.color.text.primary,
    '--local-manage-kind-color': tokens.color.text.tertiary,
    '--local-manage-kind-weight': tokens.font.weight.medium,
    '--local-manage-kind-separator-color': tokens.color.text.quaternary,
    // Matches .manage-identity's gap so the separator sits centred between kind and title.
    '--local-manage-kind-gap': tokens.spacing.md,
    '--local-manage-kind-max-width': '50%',
    '--local-manage-title-hover-bg': tokens.color.background.secondary,
    '--local-manage-title-radius': tokens.radius.md,
    '--local-manage-title-edit-color': tokens.color.text.tertiary,
    '--local-manage-title-edit-size': tokens.font.size.textXs,
    '--local-manage-title-edit-gap': tokens.spacing.sm,
    '--local-manage-title-hover-pad-inline': tokens.spacing.sm,
  },
};
